module.exports = __webpack_public_path__ + "static/saalik-2b3c55f6a574c5133839b2293fd85475.jpg";